<template lang="pug">
v-text-field.input-group--focused(
  :append-icon="show ? 'fa-eye' : 'fa-eye-slash'", :rules='[rules.required]',
  :type="show ? 'text' : 'password'",
  :value='value',
  @input="$emit('update:value', $event)",
  @click:append='show = !show',
  autocomplete="on",
  v-bind="$attrs",
)
</template>

<script>
export default {
  props: {
    value: {
      validator: prop => typeof prop === 'string' || prop === null,
      required: true,
    },
  },

  data() {
    return {
      show: false,
      rules: {
        required: value => !!value || this.$attrs.label + ' is required',
      },
    };
  },
};
</script>
